/**
 * Branding configuration based on domain
 */

// Brand configurations
const BRANDS = {
  swiftrans: {
    name: 'Swiftrans',
    logo: '/swift.png',
    title: 'Merchant Dashboard | Swiftrans',
    domain: 'merchant.swiftrans.id'
  },
  payara: {
    name: 'Payara',
    logo: '/payara.webp',
    title: 'Merchant Dashboard | Payara',
    domain: 'merchant.payara.id'
  }
};

/**
 * Get current brand based on hostname
 * @returns {Object} Brand configuration
 */
export function getCurrentBrand() {
  const hostname = window.location.hostname;
  
  // Check if domain matches Payara
  if (hostname.includes('payara.id')) {
    return BRANDS.payara;
  }
  
  // Default to Swiftrans
  return BRANDS.swiftrans;
}

/**
 * Get brand logo URL
 * @returns {string} Logo URL
 */
export function getBrandLogo() {
  return getCurrentBrand().logo;
}

/**
 * Get brand name
 * @returns {string} Brand name
 */
export function getBrandName() {
  return getCurrentBrand().name;
}

/**
 * Get brand title
 * @returns {string} Brand title
 */
export function getBrandTitle() {
  return getCurrentBrand().title;
}

/**
 * Set document title based on brand
 * @param {string} pageTitle - Optional page title to append
 */
export function setBrandTitle(pageTitle = null) {
  const brand = getCurrentBrand();
  document.title = pageTitle 
    ? `${pageTitle} | ${brand.name}`
    : brand.title;
}

/**
 * Composable for Vue components
 * @returns {Object} Branding utilities
 */
export function useBranding() {
  const brand = getCurrentBrand();
  
  return {
    brandName: brand.name,
    brandLogo: brand.logo,
    brandTitle: brand.title,
    setBrandTitle
  };
}

export default {
  getCurrentBrand,
  getBrandLogo,
  getBrandName,
  getBrandTitle,
  setBrandTitle,
  useBranding
};

